// extracted by mini-css-extract-plugin
module.exports = {"TabActive":"tab_TabActive__1fUCN","TabInactive":"tab_TabInactive__172Ra"};